/* A utiliser avec la fonction cc_wordpress_object() du fichier wordpress.php qui doit être appelée dans le tag body */
export class Wordpress {

  public static config: any;

  public static init() {
    Wordpress.config = $('body').data('wordpress');

  }

  public static get_template_directory_uri() {
    return Wordpress.config.get_template_directory_uri;
  }
}